import { getUsersList,
  updateUserRequest,
  requestLogin,
  requestLogout,
  fishLogin,
  addUserRequest,
  delUserRequest,
  userPasswdModify,
  userPasswdModifyNew,
  checkPasswdToken
} from '../api/api'
import { getUrl } from '../utils/global/geturl'
import ajax from "../api/ajax";

const state = {
  user: null,
  isLogin: false,
  cacheTabsActive: 0
}

const getters = {
  getCacheTabsActive: state => state.cacheTabsActive
}
const mutations = {
  SET_DOING_LOGIN (state, isLogin) {
    state.isLogin = isLogin
  },
  SET_LOGIN_USER (state, user) {
    state.user = user
  },
  SET_LOGIN_TOKEN (state, token) {
    if (token) {
      sessionStorage.setItem('token', token)
      localStorage.setItem('token', token)
    } else {
      sessionStorage.removeItem('token')
      localStorage.removeItem('token')
    }
  },
  SET_USER_TABS_ACTIVE (state, info) {
    state.cacheTabsActive = info
  }
}

const actions = {
  async createUserMethod ({commit}, params) {
    return addUserRequest(params).then(response => response)
  },
  async getLoginUser ({commit}) {
    // 模拟请求用户信息
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        var user = sessionStorage.getItem('user')
        var user = localStorage.getItem('user')
        // console.log(JSON.parse(user))
        commit('SET_LOGIN_USER', JSON.parse(user))
        resolve({bool: true, user})
      }, 1000)
    })
  },
  async userPasswordModify ({commit},params) {
    ajax.defaults.timeout = 15000;
    return userPasswdModify(params).then(response => response)
  },
  async userPasswordModifyNew ({commit},params) {
    ajax.defaults.timeout = 15000;
    return userPasswdModifyNew(params).then(response => response)
  },
  async loginMethod ({commit}, params) {
    ajax.defaults.timeout = 5000;
    return requestLogin(params).then(response => response)
  },
  async userPasswordTokenCheck({commit},params) {
    ajax.defaults.timeout = 15000;
    return checkPasswdToken(getUrl(params)).then(response => response)
  },
  async fishLoginMethod ({commit}, params) {
    return fishLogin(params).then(response => response)
  },
  async logout ({commit}) {
    // 模拟退出
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        sessionStorage.removeItem('user')
        localStorage.removeItem('user')
        sessionStorage.removeItem('token')
        localStorage.removeItem('token')
        commit('SET_LOGIN_USER', null)
        resolve({bool: true})
      }, 2000)
    })
  },
  async newLogout ({commit}, params) {
    return requestLogout(getUrl(params)).then(response => response)
  },
  async getUserMethod ({commit}, params) {
    return getUsersList(getUrl(params)).then(response => response.data.detail)
  },
  async updateUserMethod ({commit}, params) {
    return updateUserRequest(params).then(response => response)
  },
  async cacheUserTabsActive ({commit}, params) {
    //console.log(params,1111111111111)
    commit('SET_USER_TABS_ACTIVE', params)
  },
  async deleteUserMethod ({commit}, params) {
    return delUserRequest(params).then(response => response)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user.js